<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Controls</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (thermostatLocationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Thermostat Location:</label>
            <select class="halfWidthInputField" #thermostatLocationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatLocationSelection.Name)"
              (change)="selectionChanged(thermostatLocationSelection, thermostatLocationInput.value)"
              [value]="thermostatLocationSelection.Value.toString()">
              @for (allowable of thermostatLocationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatLocationSelection.Value && thermostatLocationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (thermostatTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Thermostat Type:</label>
            <select class="halfWidthInputField" #thermostatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatTypeSelection.Name)"
              (change)="selectionChanged(thermostatTypeSelection, thermostatInput.value)"
              [value]="thermostatTypeSelection.Value.toString()">
              @for (allowable of thermostatTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatTypeSelection.Value && thermostatTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
